export const isDjUser = (user) => user?.role === "dj";
